const routes = {
  home: "/",
  // login: "/login",
  register: "/register",
  postDetail: "/post/:id",
  message: "/message",
  conversation: "/message/:id",
  profile: "/profile/:id",
  discover: "/discover",
  notify: "/notify",
  forgotPass: "/forgotPassword",
  resetPass: "/resetPassword",
  notfound: "*"
}

export default routes;